import { Link } from 'react-router-dom';

// Components
import { TextCustom } from '../../atoms';

// Assets
import botonCerrar from '../../../assets/icons/btn-cerrar.svg';

// Hooks
import { renderTexto, urlSeguro } from '../../molecules/DropMenuOptions';
import { useGetSeguros } from '../../molecules/CardSeguroTitulo/query';
import {
  DEFAULT_URL,
  LOGOS,
  NOMBRES_BY_PROYECT,
  segurosActivos,
  segurosByProyect,
} from '../../../utils';
import { RENDER_IMAGEN_BY_PROYECT, SUB_MENU_MOBILE } from './utils';

const MobileMenu = ({ handelCloseMenu }) => {
  const { data } = useGetSeguros();

  const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

  const todos_seguros = segurosActivos(data?.data);
  const seguros = segurosByProyect(todos_seguros);

  return (
    <div id="mobile-menu" className=" mobile-menu">
      <div className="px-[5%] py-5">
        <div className="flex justify-between items-center">
          <Link to='/'>
            <img src={LOGOS[whiteLabel]} alt="Logo" className="w-44" />
          </Link>
          <div onClick={handelCloseMenu}>
            <img src={botonCerrar} alt="btn cerrar" />
          </div>
        </div>
      </div>
      <div className="grid-item-menu-mobile" onClick={handelCloseMenu}>
        <div className="pb-4">
          <TextCustom text="Seguros" className="item-menu-mobile fontPBold" />
          <hr />
          <div className="grid grid-cols-2 gap-3 pt-4">
            {seguros.map(seguro => (
              <Link
                to={urlSeguro[seguro.codigo]}
                key={seguro.codigo}
                className="item-menu-mobile fontPRegular"
              >
                <div className="flex justify-between items-center">
                  <TextCustom
                    text={
                      <>
                        <span className="text-[10px] fontPRegular ">
                          {seguro.nombre.includes('Seguro de ')
                            ? 'Seguro de'
                            : 'Seguro'}
                        </span>
                        {seguro.nombre.split('Seguro de')[1] ||
                          seguro.nombre.split('Seguro')[1]}
                      </>
                    }
                    className="color-contrast-content text-xs fontPBold w-16"
                  />
                  {RENDER_IMAGEN_BY_PROYECT[whiteLabel][seguro.codigo]}
                </div>
                <div className={`flex flex-col justify-center`}>
                  <TextCustom
                    text={renderTexto[seguro.codigo]}
                    className="color-contrast-content text-[10px] fontPRegular mt-2"
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="py-4">
          <TextCustom
            text={NOMBRES_BY_PROYECT[whiteLabel]}
            className="item-menu-mobile fontPBold"
          />
          <hr />
          <div className="grid grid-cols-2 gap-3 pt-4">
            {SUB_MENU_MOBILE[whiteLabel].map((itemMenu, index) => (
              <Link key={index} to={itemMenu.ruta} className="item-menu-mobile">
                <div className="flex justify-between items-end">
                  <TextCustom
                    text={itemMenu.title}
                    className="color-contrast-content text-xs fontPBold mt-4"
                  />
                </div>
                <div className={`flex flex-col justify-center`}>
                  <TextCustom
                    text={itemMenu.description}
                    className="color-contrast-content text-[10px] fontPRegular mt-2"
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="pt-5">
          <Link
            to="/cotizar"
            className="item-menu-mobile fontPSemiBold bg-secondary w-full block text-center p-3 rounded-3xl"
          >
            Cotizar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
